export interface ReportTypeModel {
  title: ReportTypeFilter;
  value: ReportTypeParam;
  name: string;
  qaAttr: string;
}

export enum ReportTypeFilter {
  X_REPORT = 'xreport',
  Z_REPORT = 'zreport',
  IBERICA_REPORT = 'iberica',
}

export enum ReportTypeParam {
  X_REPORT = 1,
  Z_REPORT = 0,
  IBERICA_REPORT = 2,
}
